import React, { useContext, useLayoutEffect, useState } from "react";
import { distinctUntilChanged } from "rxjs/operators";
import { Subject } from "rxjs";

import { TableContext, TABLE_INIT_STATE } from "./TableContext";
import { ITableState, IAction } from "./interfaces";

type Props = {
  dispatch: (action: IAction) => void;
} & ITableState;

export const CustomWidget: React.FC<{
  children: (props: Props) => JSX.Element | null;
  compare: (next: ITableState, prev: ITableState) => boolean;
}> = ({ children, compare }) => {
  const [tableState, setTableState] = useState(TABLE_INIT_STATE);
  const { subscribe, dispatch } = useContext(TableContext);

  useLayoutEffect(() => {
    const tableStateObserver$ = new Subject<ITableState>();
    const tableSubscription = tableStateObserver$
      .pipe(distinctUntilChanged(compare))
      .subscribe(state => {
        setTableState(state);
      });

    const subscription = subscribe(tableStateObserver$);

    return () => {
      tableStateObserver$.complete();
      subscription.unsubscribe();
      tableSubscription.unsubscribe();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return children({ dispatch, ...tableState });
};
